<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Cohorts</h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a href="/">Home</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <a href="/">Settings</a>
                                </li>
                                <li class="breadcrumb-item active">Cohorts</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right ml-1" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Add New Cohort</span></button>
                    
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
                    
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showCreatePanel">
                            <div class="card-header">
                                <h4 class="card-title">Add New Cohort</h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <cohort-form @completed="getCohorts" @cancel="showCreatePanel = !showCreatePanel"></cohort-form>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="card-title">
                                    {{trans('general.filter')}}
                                </h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">{{trans('general.keyword')}}</label>
                                            <input class="form-control" name="keyword" v-model="filterCohortForm.keyword">
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="cohorts.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterCohortForm.sort_by" :order="filterCohortForm.order" @updateSortBy="value => {filterCohortForm.sort_by = value}"  @updateOrder="value => {filterCohortForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="cohorts.total">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="cohort in cohorts.data">
                                            <td v-text="cohort.name"></td>
                                            <td class="table-option">
                                                <div class="btn-group">
                                                    <button class="btn btn-info btn-sm" v-tooltip="'Edit Cohort'" @click.prevent="editCohort(cohort)"><i class="feather icon-edit"></i></button>
                                                    <button class="btn btn-danger btn-sm" :key="cohort.id" v-confirm="{ok: confirmDelete(cohort)}" v-tooltip="'Delete Cohort'"><i class="feather icon-trash-2"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <module-info v-if="!cohorts.total"  module="general" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" v-if="!showCreatePanel" @click="showCreatePanel = !showCreatePanel"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterCohortForm.page_length" :records="cohorts" @updateRecords="getCohorts"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   
   </div>
    </div>
</template>

<script>
    import cohortForm from './form'
    import sortBy from '../../../components/sort-by'

    export default {
        components : { cohortForm,sortBy },
        data() {
            return {
                cohorts: {
                    total: 0,
                    data: []
                },
                filterCohortForm: {
                    keyword: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                orderByOptions: [
                    {
                        value: 'name',
                        translation: 'Name'
                    }
                ],
                showCreatePanel: false,
                showFilterPanel: false
            };
        },
        mounted(){
            if(!helper.hasPermission('access-settings')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            this.getCohorts();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getCohorts(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterCohortForm);
                axios.get('/api/setting/cohort?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.cohorts = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editCohort(cohort){
                this.$router.push('/setting/cohort/'+cohort.id+'/edit');
            },
            confirmDelete(cohort){
                return dialog => this.deleteCohort(cohort);
            },
            deleteCohort(cohort){
                axios.delete('/api/setting/cohort/'+cohort.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getCohorts();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            }
        },
        watch: {
            filterCohortForm: {
                handler(val){
                    setTimeout(() => {
                        this.getCohorts();
                    }, 500)
                },
                deep: true
            }
        }
    }
</script>
